'use client';

/* eslint-disable @typescript-eslint/naming-convention */

import { Info } from '@gds/Icons/Paths/Info';
import { useModal } from '@modal/Hooks/UseModal';

import styles from './FinanceInfoTooltip.module.css';

export const FinanceInfoTooltip = ({
  title,
  disclaimer,
}: {
  title: string;
  disclaimer: string;
}) => {
  const { openModal } = useModal();

  const handleRequestBtnClick = () => {
    openModal(<p dangerouslySetInnerHTML={{ __html: disclaimer }} />, {
      header: title,
      modalClassName: styles.modalContainer,
      modalBodyClassName: styles.modalBodyClassName,
    });
  };

  return (
    <button
      className={styles.info}
      onClick={() => handleRequestBtnClick()}
      data-test-id="financeInfoTooltip"
    >
      <Info />
    </button>
  );
};
